import { Grid, Menu } from "antd";
import { useMenuItemIsPermitted } from "components/util-components/ProtectedPermissionRendering";
import navigationConfig from "configs/NavigationConfig";
import { NAV_TYPE_SIDE, SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import useNotificationsSidebar from "hooks/useNotificationsSidebar";
import _ from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { onMobileNavToggle } from "redux/actions/Theme";
import utils from "utils";
import Icon from "../util-components/Icon";
import IntlMessage from "../util-components/IntlMessage";
import "assets/scss/notifications-sidebar.scss";
const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const NOTIFICATIONS_MENU_KEY = "notifications";

const renderMenuIcon = (icon, menuKey, showBadge, unreadCount) => {
  if (!icon) return null;
  return (
    <span className="side-nav-menu-icon">
      <Icon type={icon} />
      {menuKey === NOTIFICATIONS_MENU_KEY && showBadge ? (
        <span className="nav-notification-badge">{unreadCount}</span>
      ) : null}
    </span>
  );
};

const SideNavContent = ({ navList, showNotificationBadge, unreadCount, ...props }) => {
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };
  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navList.flatMap((menu) => {
        if (!menu.display) return [];
        return menu.submenu.length > 0 ? (
          <SubMenu
            icon={renderMenuIcon(menu.icon, menu.key, showNotificationBadge, unreadCount)}
            key={menu.key}
            popupClassName="side-nav-submenu-popup"
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.flatMap((subMenuFirst) => {
              if (!subMenuFirst.display) return [];
              return subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  icon={renderMenuIcon(
                    subMenuFirst.icon,
                    subMenuFirst.key,
                    showNotificationBadge,
                    unreadCount
                  )}
                  key={subMenuFirst.key}
                  popupClassName="side-nav-submenu-popup"
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.flatMap((subMenuSecond) => {
                    if (!subMenuSecond.display) return [];
                    return (
                      <Menu.Item
                        key={subMenuSecond.key}
                        icon={renderMenuIcon(
                          subMenuSecond.icon,
                          subMenuSecond.key,
                          showNotificationBadge,
                          unreadCount
                        )}
                      >
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                        <Link
                          onClick={() => closeMobileNav()}
                          to={subMenuSecond.path}
                        />
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={subMenuFirst.key}
                  icon={renderMenuIcon(
                    subMenuFirst.icon,
                    subMenuFirst.key,
                    showNotificationBadge,
                    unreadCount
                  )}
                >
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link
                    onClick={() => closeMobileNav()}
                    to={subMenuFirst.path}
                  />
                </Menu.Item>
              );
            })}
          </SubMenu>
        ) : (
          <Menu.Item
            key={menu.key}
            icon={renderMenuIcon(
              menu.icon,
              menu.key,
              showNotificationBadge,
              unreadCount
            )}
          >
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? (
              <Link onClick={() => closeMobileNav()} to={menu.path} />
            ) : null}
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

const TopNavContent = ({ navList, ...props }) => {
  const { topNavColor, localization } = props;

  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navList.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  const [filterdNavList, setFilterdNavList] = useState([]);
  const [isMenuItemPermitted] = useMenuItemIsPermitted();
  const { unreadCount, showBadge } = useNotificationsSidebar();
  const applyPermissionsToPages = (menuItem) => {
    if (
      menuItem.submenu === null ||
      menuItem.submenu === undefined ||
      menuItem.submenu.length === 0
    ) {
      if (
        menuItem.moduleKey === undefined ||
        menuItem.permissionId === undefined
      ) {
        return { ...menuItem, display: true };
      }
      return {
        ...menuItem,
        display: isMenuItemPermitted({
          moduleKey: menuItem.moduleKey,
          permissionId: menuItem.permissionId,
        }),
      };
    }

    menuItem.submenu = menuItem.submenu.map((subItem) => {
      const returnObj = applyPermissionsToPages(subItem);
      const isObjDisplay = returnObj.display;
      if (subItem.display === undefined) {
        subItem.display = isObjDisplay;
      } else {
        subItem.display = isObjDisplay || subItem.display;
      }
      if (menuItem.display === undefined) {
        menuItem.display = subItem.display;
      } else {
        menuItem.display = subItem.display || menuItem.display;
      }
      return returnObj;
    });

    return menuItem;
  };
  useEffect(() => {
    const clonedArr = _.cloneDeep(navigationConfig);
    const navList = clonedArr.map((item) => {
      return applyPermissionsToPages(item);
    });
    setFilterdNavList(navList);
  }, [navigationConfig]);
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent
      navList={filterdNavList}
      showNotificationBadge={showBadge}
      unreadCount={unreadCount}
      {...props}
    />
  ) : (
    <TopNavContent navList={filterdNavList} {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
